// extracted by mini-css-extract-plugin
export default {"form":"Input_form__SiBFZ","input":"Input_input__wWSom","ul":"Input_ul__+HkbH","li":"Input_li__AYS4o"};